import { MODIFIERS, hasLinksInSelection, removeLinksInSelection, } from 'wix-rich-content-common';
import TextLinkButton from './TextLinkButton';
import { openLinkModal } from './helpers';
export default (function (_a) {
    var helpers = _a.helpers, isMobile = _a.isMobile, anchorTarget = _a.anchorTarget, relValue = _a.relValue, t = _a.t, theme = _a.theme, getEditorState = _a.getEditorState, setEditorState = _a.setEditorState;
    return ({
        TextButtonMapper: function () { return ({
            Link: {
                component: TextLinkButton,
                isMobile: true,
                position: { mobile: 5 },
                keyBindings: [
                    {
                        keyCommand: {
                            command: 'link',
                            modifiers: [MODIFIERS.COMMAND],
                            key: 'k',
                        },
                        commandHandler: function (editorState) {
                            if (hasLinksInSelection(editorState)) {
                                return removeLinksInSelection(editorState);
                            }
                            else {
                                openLinkModal(helpers, isMobile, anchorTarget, relValue, t, theme, getEditorState, setEditorState);
                            }
                        },
                    },
                ],
            },
        }); },
    });
});
//# sourceMappingURL=createLinkToolbar.js.map